import script from "./PageHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeader.vue?vue&type=script&lang=ts&setup=true"

import "./PageHeader.vue?vue&type=style&index=0&id=f47b20f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f47b20f0"]])

export default __exports__